import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, FormGroup, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useState, useEffect, useRef } from 'react';
import { Auth, SignOut, AddUserToGroup, CheckGroupName, ListGroupMembers, ListGroups, GetUser } from '../../../functions/ZIA'
import Spinner from 'react-bootstrap/Spinner';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBroom, faPaste, faCopy, faI } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Badge from 'react-bootstrap/Badge';
import ProgressBar from 'react-bootstrap/ProgressBar';

library.add(faBroom, faPaste, faCopy)

function ListUserGroups({ groups }) {
    const [isLoading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Authenticating...")
    const [tenant, setTenant] = useState("Rheintec");
    const [user, setUser] = useState("");
    const [userGroups, setUserGroups] = useState([])
    const [outputConsole, setOutputConsole] = useState("");
    const [JSESSIONID, setJSESSIONID] = useState("");
    const [loadingProgress, setLoadingProgress] = useState(0)
    const textareaRef = useRef();
    const [validated, setValidated] = useState(false);


    function copyList(list) {
        const text = ListToText(list);
        navigator.clipboard.writeText(text);
    }

    function ListToText(list) {
        let text = "";
        for (let i = 0; i < list.length; i++) {
            text += i === 0 ? list[i] : "\n" + list[i];
        }
        return text;
    }

    function appendConsole(text) {
        setOutputConsole(prevOutput => prevOutput + text);
    }
    function appendConsoleSeperatorMain(skipNewLine) {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount));
        setOutputConsole(prevOutput => prevOutput + (skipNewLine ? "" : "\n") + dashes);
    }
    function appendConsoleSeperatorSecondary() {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount / 2));
        setOutputConsole(prevOutput => prevOutput + "\n" + "\t" + dashes);
    }


    async function handleSubmit(event) {

        //Prerequisites
        setUserGroups([])
        setLoadingProgress(0);
        setOutputConsole(``);
        setLoading(true);
        event.preventDefault();
        setLoadingProgress(10);

        //Authenticate
        setLoadingMessage("Initiating Session...");
        const json_session = await Auth(tenant);
        setLoadingProgress(40);

        const session = json_session.session;
        setJSESSIONID(session);
        setOutputConsole(`Authenticated`);
        appendConsoleSeperatorMain();
        console.log(session);

        try {


            setLoadingMessage("Getting user...");
            const user_response = await GetUser(user, session, tenant)
            const user_json = await user_response.json()
            setLoadingProgress(80);

            if (user_response.status === 200) {
                const groups = user_json.user.groups
                setUserGroups(groups.map(group => group.name));
                appendConsole("\n Groups:")
                for (const group of groups) {
                    appendConsole(`\n\t${group.name}`);
                }

                appendConsoleSeperatorMain();
            }
            else {
                console.log(user_json);
                appendConsole(`\nError: ${user_json.message}`);
                appendConsoleSeperatorMain();
            }
            setLoadingProgress(90);
            terminateSession(session)


        }
        catch (error) {
            appendConsole(`\nError: ${error.message}`)
            console.log(error)
            setLoading(false);
            terminateSession(session)
        }



    }

    // Function to scroll the textarea to the bottom
    const scrollToBottom = () => {
        textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    };

    const scrollToTop = () => {
        textareaRef.current.scrollTop = 0;
    };
    useEffect(() => {
        scrollToBottom();
    }, [outputConsole])

    useEffect(() => {
        scrollToTop();
    }, [isLoading])



    async function terminateSession(JSESSIONID) {
        //Signout
        setLoadingMessage("Terminating Session...");
        await SignOut(JSESSIONID, tenant);
        setLoadingProgress(100);
        setLoading(false);
    }
    return (
        <Container className=' pt-4 px-5 text-white pb-6'>
            <Row>
                <Col>
                    <Form validated={validated} onSubmit={handleSubmit}>
                        <FormGroup controlId="company">
                            <Form.Label>
                                Select tenant
                            </Form.Label>
                            <Form.Select value={tenant} onChange={(e) => setTenant(e.target.value)} >
                                {
                                    Object.keys(groups).map((key, index) => (
                                        <option key={index} value={key}>{key}</option>
                                    ))

                                }
                            </Form.Select>
                        </FormGroup>

                        <FormGroup controlId="groupName" className='mt-4'>
                            <Form.Label>
                                User email
                            </Form.Label>
                            <Form.Control type='text' required value={user} onChange={(e) => setUser(e.target.value)} placeholder='user@rheintec.ch' />
                        </FormGroup>



                        <Button className='mt-4 text-light' type='submit' disabled={isLoading} >
                            {isLoading ?
                                <span>
                                    <Spinner
                                        variant='light'
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    {"  " + loadingMessage}
                                </span> : 'List User Groups'}
                        </Button>
                    </Form>
                </Col>
            </Row>
            <Row className='mt-5 '>
                <Col>
                    <ProgressBar now={isLoading ? loadingProgress : 0} />
                </Col>
                <Col md="auto" className='text-end'>
                    <Button disabled={userGroups.length > 0 ? false : true} onClick={(event) => { copyList(userGroups) }} className='rounded-0 pt-0 pb-0 pm-1' size='sm' variant={userGroups.length > 0 ? 'success' : 'primary'}>
                        <FontAwesomeIcon className='me-1' size='lg' icon="fa-solid fa-copy" style={{ color: "#ffffff", }} />
                        Copy groups
                        <Badge className='ms-1' bg="dark">{userGroups.length}</Badge>
                    </Button>
                </Col>
            </Row>
            <Row className='mt-0 text-center'>
                <Col className=''>
                    <textarea value={outputConsole} className='w-100 bg-dark-subtle text-rheintec-blue output-terminal' rows="20" readOnly ref={textareaRef}>
                    </textarea>
                </Col>

            </Row>

        </Container >

    );

}

export default ListUserGroups;